import { window } from './facade/browser';
export function isBs3() {
    return window.__theme !== 'bs4';
}
//# sourceMappingURL=ng2-bootstrap-config.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/noomo/Desktop/project/newCefKid/cefapp2/node_modules/ng2-bootstrap/utils/ng2-bootstrap-config.js
// module id = ../../../../ng2-bootstrap/utils/ng2-bootstrap-config.js
// module chunks = vendor